const CHAR_COUNT = 8;
const REQ_UPPERCASE = true;
const REQ_NUMBER = true;
const REQ_SPECIALCHAR = true;

const CASE_REGEX = /[A-Z+]/;
const SPECIAL_REGEX = /[?=.*#!@$%^&*-]/;
const NUMBER_REGEX = /[0-9+]/;

export const passwordValidation = pw => {
  let password = pw.trim();
  let responseArray = [];

  if (password.length < CHAR_COUNT) {
    responseArray.push(`Password length must be ${CHAR_COUNT} or more characters.`);
  }

  if (REQ_UPPERCASE && !CASE_REGEX.test(password)) {
    responseArray.push('Password must contain at least one uppercase character.');
  }

  if (REQ_NUMBER && !NUMBER_REGEX.test(password)) {
    responseArray.push('Password must contain at least one numerical digit.');
  }

  if (REQ_SPECIALCHAR && !SPECIAL_REGEX.test(password)) {
    responseArray.push('Password must contain at least one special character.')
  }
  if (!responseArray.length) {
    return [true, ''];
  }
  return [false, <>{responseArray.map(val => <div>{val}</div>)}</>]

}